// extracted by mini-css-extract-plugin
export default {"offScreen":"LiveAnnouncer_offScreen__dGZiY"};